export default __webpack_public_path__ + "static/media/blush-soft-autumn.79fa1a48.png";